
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f72Ys", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a68618604fa10eaa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $a68618604fa10eaa$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Alle Sites',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "Schlie\xdfen",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(derzeit nicht verf\xfcgbar)",
    'navigation.global-shortcuts.sites': "{productName}\xa0Sites"
};

});


//# sourceMappingURL=de.570cc79c.js.map
